import { render, staticRenderFns } from "./PagamentoPendente.vue?vue&type=template&id=4ff12bb9&"
import script from "./PagamentoPendente.vue?vue&type=script&lang=js&"
export * from "./PagamentoPendente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports